/**
 * DashboardContentTable
 * Renders normalized content rows for dashboard collection management views.
 *
 * Data expectations:
 * - `items` come from `contentService.listContent` (already normalized/sorted).
 * - `collectionKey` maps labels/summary rules through `contentConfig`.
 *
 * Responsibilities:
 * - render read-only table output
 * - delegate edit/delete actions back to parent container
 */
import { getContentConfig, summarizeContent } from '../../utils/contentConfig';
import { formatDate } from '../../utils/time';

export default function DashboardContentTable({
  collectionKey,
  items,
  onEdit,
  onDelete,
  deletingId,
  canDelete,
}) {
  const config = getContentConfig(collectionKey);
  const showSortOrder = collectionKey === 'models';

  if (items.length === 0) {
    return (
      <div className="state-card">
        <p>No {config?.title.toLowerCase()} found.</p>
      </div>
    );
  }

  return (
    <div className="table-wrap">
      <table className="content-table">
        <thead>
          <tr>
            <th>Title</th>
            {showSortOrder ? <th>Order</th> : null}
            <th>Status</th>
            <th>Summary</th>
            <th>Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>{item.title}</td>
              {showSortOrder ? <td>{item.sortOrder ?? 'auto'}</td> : null}
              <td>
                <span className={`status-pill status-${item.status || 'draft'}`}>
                  {item.status || 'draft'}
                </span>
              </td>
              <td>{summarizeContent(item, collectionKey) || 'N/A'}</td>
              <td>{formatDate(item.updatedAt || item.createdAt)}</td>
              <td className="table-actions">
                <button type="button" onClick={() => onEdit(item)}>
                  Edit
                </button>
                {canDelete ? (
                  <button
                    type="button"
                    className="danger"
                    onClick={() => onDelete(item)}
                    disabled={deletingId === item.id}
                  >
                    {deletingId === item.id ? 'Deleting...' : 'Delete'}
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
